import Utils from '@/services/utils'
import { initializeAxios } from './apiUtils'

/**
 * @returns {string}
 */
const getDesignHubBaseUrl = () => {
  const appDomain = Utils.getAppDomain()

  const baseUrl =
    process.env.VUE_APP_HUB_FRONTEND || // Local development env variable (only)
    `https://${process.env.VUE_APP_HUB_SUBDOMAIN}.${appDomain}/`

  return Utils.processBaseUrl(baseUrl)
}

/**
 * @returns {string}
 */
const getDesignHubApiBaseUrl = () => {
  const appDomain = Utils.getAppDomain()

  const baseUrl =
    process.env.VUE_APP_HUB_API_BASE_URL || // Local development env variable (only)
    `https://${process.env.VUE_APP_HUB_API_SUBDOMAIN}.${appDomain}/api/`

  return Utils.processBaseUrl(baseUrl)
}

const HTTP = initializeAxios(getDesignHubApiBaseUrl())

/**
 * @returns {AxiosPromise}
 */
const fetchHubFilters = () => {
  return HTTP.get('/styles/filters')
}

const DesignHub = {
  getDesignHubApiBaseUrl,
  getDesignHubBaseUrl,
  fetchHubFilters
}

export default DesignHub
